<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="equipment?.id">
      {{ 'EQUIPMENTS.DIALOG.EDIT' | translate }}
    </h2>

    <h2 class="field-dialog__header__title" *ngIf="!equipment?.id">
      {{ 'EQUIPMENTS.DIALOG.ADD' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group
    class="field-dialog__content"
    [(selectedIndex)]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab [label]="'EQUIPMENTS.DIALOG.GENERAL' | translate">
      <tab-new-general [equipmentForm]="equipmentForm" [isViewMode]="isViewMode"></tab-new-general>
    </mat-tab>

    <mat-tab *ngIf="hasFlagWarranties && isUpdate" [label]="'EQUIPMENTS.DIALOG.WARRANTIES' | translate">
      <div class="field-dialog__content__scroll" id="equipment-container"></div>
    </mat-tab>

    <mat-tab [disabled]="!equipmentForm?.get('type')?.value">
      <ng-template mat-tab-label>
        <span [ngClass]="{ 'mat-tab-label-disabled': !equipmentForm?.get('type')?.value }">
          {{ 'EQUIPMENTS.DIALOG.CUSTOM_FIELDS' | translate }}
        </span>
        <div *ngIf="equipmentForm?.get('type')?.value && equipmentForm?.value.customFields.length" class="tab-badge">
          {{ equipmentForm?.value.customFields.length | badge }}
        </div>
      </ng-template>

      <disclaimer *ngIf="isViewMode" [message]="'EQUIPMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-custom-fields [customFieldsArray]="equipmentForm.get('customFields')" [isViewMode]="isViewMode">
      </tab-custom-fields>
    </mat-tab>

    <mat-tab *ngIf="equipment?.id" [label]="'EQUIPMENTS.DIALOG.PHOTOS' | translate">
      <disclaimer *ngIf="isViewMode" [message]="'EQUIPMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>

      <tab-attachments [equipment]="equipment" [isViewMode]="isViewMode"></tab-attachments>
    </mat-tab>

    <mat-tab *ngIf="equipment?.id" [label]="'EQUIPMENTS.DIALOG.LOGS' | translate">
      <tab-equipment-historic></tab-equipment-historic>
    </mat-tab>

    <mat-tab *ngIf="equipment?.id" [label]="'EQUIPMENTS.DIALOG.MAINTENANCES' | translate">
      <tab-maintenances></tab-maintenances>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      mat-raised-button
      (click)="generateInputToSave()"
      [disabled]="isSaving || equipmentForm?.invalid"
    >
      {{ 'EQUIPMENTS.DIALOG.BUTTON.SAVE' | translate }}
    </button>

    <div *ngIf="equipment?.id">
      <button
        *ngIf="!equipment.archived"
        mat-icon-button
        class="dialog-equipment__secondary-button"
        (click)="archiveOrUnarchiveEquipment(true)"
        [disabled]="isSaving || equipmentForm?.invalid"
        matTooltip="{{ 'EQUIPMENTS.DIALOG.BUTTON.ARCHIVE' | translate }}"
      >
        <mat-icon>archive</mat-icon>
      </button>

      <button
        *ngIf="equipment.archived"
        mat-icon-button
        class="dialog-equipment__secondary-button"
        (click)="archiveOrUnarchiveEquipment(false)"
        [disabled]="isSaving || equipmentForm?.invalid"
        matTooltip="{{ 'EQUIPMENTS.DIALOG.BUTTON.UNARCHIVE' | translate }}"
      >
        <mat-icon>unarchive</mat-icon>
      </button>
    </div>
  </div>
</div>
